import ImageTile from './image-tile'
export default ImageTile
